module.exports = __webpack_public_path__ + "static/aice-17d14067cf6f9eecf61b08ba15702c72.png";